import cn from 'classnames';
import * as bjTypes from '@api/types/blackjack';
import * as bjUtils from '@utils/blackjack';
import Card, { TCardSize } from '../card';
import { CSSProperties, useContext } from 'react';
import {
  getPositionClasses,
  getReversedClasses,
  PlayerContext,
} from './player';
import { ROOM } from '@consts/blackjack';
import styles from './player.module.scss';

const MAX_PLAYERS = 7;
const STACKING_RATE = 0.8;
const HITABLE_CARDS_COUNT = 21;
const VISIBLE_CARDS_AMOUNT_BY_ALL_PLAYER = 1;

const stackCards = (cardIdx: number, isReversed: boolean): CSSProperties => ({
  bottom: `${STACKING_RATE * cardIdx}rem`,
  zIndex: !isReversed ? cardIdx : HITABLE_CARDS_COUNT - cardIdx,
});

const PlayerCards = (): JSX.Element => {
  const { player, playerNumber, isReversed, positionInTable } =
    useContext(PlayerContext);

  if (!player) return <></>;

  const { cards, winner, tickets } = player;

  /* ClassNames */

  const cardsClasses: string = getPositionClasses('cards', positionInTable);
  const cardsListClasses: string = getReversedClasses(
    'cards__list',
    isReversed
  );
  const cardsPointsClasses: string = cn(
    getReversedClasses('cards__points', isReversed),
    {
      [styles.isWinner]: winner,
    }
  );

  /* Components */

  const cardSize: TCardSize = playerNumber === 0 ? 'big' : 'normal';
  const roomSlug: bjTypes.TRoomSlug =
    ROOM.COLORS[MAX_PLAYERS as bjTypes.TMaxPlayers];

  const CardsPoints: JSX.Element = cards[0] && (
    <span className={cardsPointsClasses}>
      {bjUtils.calculateBlackjackCardsPoints(cards).points}
    </span>
  );

  const Cards: JSX.Element[] =
    cards[0] &&
    cards.map(({ type, order }, idx) => (
      <>
        {cards.length - 1 === idx ? (
          <div style={stackCards(idx, isReversed)}>
            {CardsPoints}
            <Card key={type + order} size={cardSize} card={type} />
          </div>
        ) : (
          <Card
            key={type + order}
            size={cardSize}
            card={type}
            style={stackCards(idx, isReversed)}
          />
        )}
      </>
    ));

  const BackCards: JSX.Element[] = tickets
    .slice(1)
    .map(({ roll }, idx) => (
      <Card
        key={roll}
        size={cardSize}
        back={roomSlug}
        style={stackCards(VISIBLE_CARDS_AMOUNT_BY_ALL_PLAYER + idx, isReversed)}
      />
    ));

  const PhantomCards: JSX.Element[] = [...new Array(2)].map((_, idx) => (
    <Card
      key={idx}
      size={cardSize}
      phantom={roomSlug}
      style={stackCards(idx, isReversed)}
    />
  ));

  return (
    <section className={cardsClasses}>
      <div className={cardsListClasses}>
        {false && PhantomCards}
        {false && Cards}
        {false && BackCards}
        {/* {PhantomCards} */}
        {Cards}
        {/* {currentPlayerId !== user.id && BackCards} */}
      </div>
    </section>
  );
};

export default PlayerCards;
